class FavoritesService {
  static getFavorites() {
    try {
      return JSON.parse(localStorage.getItem('favorites') || '[]');
    } catch (error) {
      console.error('Error loading favorites:', error);
      return [];
    }
  }

  static addToFavorites(movie) {
    try {
      const favorites = this.getFavorites();
      
      const movieId = movie.id;
      const existingIndex = favorites.findIndex(fav => fav.id === movieId);
      
      if (existingIndex === -1) {
        // Create a clean movie object for storage
        const movieForStorage = {
          id: movieId,
          title: movie.title,
          poster: movie.poster,
          poster_path: movie.poster_path,
          vote_average: movie.vote_average,
          release_date: movie.release_date,
          genres: movie.genres,
          videos: movie.videos
        };
        favorites.push(movieForStorage);
        localStorage.setItem('favorites', JSON.stringify(favorites));
        return true; // Added successfully
      }
      return false; // Already exists
    } catch (error) {
      console.error('Error adding to favorites:', error);
      return false;
    }
  }

  static removeFromFavorites(movieId) {
    try {
      const favorites = this.getFavorites();
      const updatedFavorites = favorites.filter(movie => movie.id === movieId ? false : true);
      localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
      return true; // Removed successfully
    } catch (error) {
      console.error('Error removing from favorites:', error);
      return false;
    }
  }

  static isFavorite(movieId) {
    try {
      const favorites = this.getFavorites();
      // Handle when movieId object is passed instead of string ID
      const idToCheck = typeof movieId === 'object' && movieId !== null ? movieId.id : movieId;
      return favorites.some(movie => movie.id === idToCheck);
    } catch (error) {
      console.error('Error checking favorite status:', error);
      return false;
    }
  }

  static getFavoritesCount() {
    try {
      return this.getFavorites().length;
    } catch (error) {
      console.error('Error getting favorites count:', error);
      return 0;
    }
  }

  static toggleFavorite(movie) {
    console.log('toggleFavorite called with:', movie); // Debug log
    console.log('Current favorites:', this.getFavorites()); // Debug log
    
    const movieId = movie.id;
    
    if (this.isFavorite(movieId)) {
      console.log('Removing from favorites'); // Debug log
      this.removeFromFavorites(movieId);
      return false; // Removed
    } else {
      console.log('Adding to favorites'); // Debug log
      this.addToFavorites(movie);
      return true; // Added
    }
  }
}

export default FavoritesService;
